import { className } from "utils/strings";
import { ReactComponent as TickIcon } from "components/icons/tick.svg";
import "./buttons.scss";
import "./CheckButton.scss";

const SMALL_SIZE = 24;
const DEFAULT_SIZE = 32;

export enum SizeVariants {
  small=SMALL_SIZE,
  default=DEFAULT_SIZE,
}

interface IProps {
  onClick: () => void;
  checked: boolean;
  hint?: string;
  size?: SizeVariants;
}

export const CheckButton = ({ onClick, checked, hint, size = SizeVariants.default }: IProps): JSX.Element => {
  return (
    <button
      className={className({
        check: true,
        "rg-button": true,
        "checked": checked,
        "unchecked": !checked,
        "size-24": size === SizeVariants.small,
        "size-32": size === SizeVariants.default
      })}
      onClick={onClick}
      title={hint}
    >
      {checked && <TickIcon />}
    </button>
  );
};
